var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"name":_vm.name,"colors":_vm.colors,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }